import { RequestService } from "../../../../../common/services/RequestService";
import { DOWNLOAD_NOTIFICATION_TO_GIBDD } from "../constants";

export const downloadNotificationByOrderId = async (profileId, orderId, emailgibdd) => {
  const response = await RequestService.get(
    DOWNLOAD_NOTIFICATION_TO_GIBDD.replace('{order_id}', orderId).replace(
      '{profile_id}',
      profileId
    ) + '?emailgibdd=' + emailgibdd,
    { responseType: 'blob' }
  );
  return response.data
};
